import { render } from "./widget-teplopoteri.vue?vue&type=template&id=fd5ccbb0&scoped=true"
import script from "./widget-teplopoteri.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-teplopoteri.vue?vue&type=script&setup=true&lang=js"

import "./widget-teplopoteri.vue?vue&type=style&index=0&id=fd5ccbb0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd5ccbb0"],['__file',"src/views/tep/tep-grid/components/widgets/widget-teplopoteri.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd5ccbb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd5ccbb0', __exports__)) {
    api.reload('fd5ccbb0', __exports__)
  }
  
  module.hot.accept("./widget-teplopoteri.vue?vue&type=template&id=fd5ccbb0&scoped=true", () => {
    api.rerender('fd5ccbb0', render)
  })

}


export default __exports__